import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
export const show = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/{creator}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
show.url = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { creator: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { creator: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            creator: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creator: typeof args.creator === 'object'
        ? args.creator.slug
        : args.creator,
    }

    return show.definition.url
            .replace('{creator}', parsedArgs.creator.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
show.get = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
show.head = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
const showForm = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
showForm.get = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CreatorPageController::show
* @see app/Http/Controllers/CreatorPageController.php:25
* @route '/{creator}'
*/
showForm.head = (args: { creator: string | { slug: string } } | [creator: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const creators = {
    show: Object.assign(show, show),
}

export default creators